import { TableColumnsType } from "antd";
import { CommonTable } from "components/atoms/table/AntdTable";
import { SubscriptionKeyListType } from "api/interfaces/subscription.interface";
import RegisterKeyModal from "../modal/registerKey";
import GenerateKeyModal from "../modal/generateKey";
import ReplaceKeyModal from "../modal/replaceKey/ReplaceKeyModal";
import { SubscriptionKeyListStyled } from "../SubscriptionStyled";
import { SubscriptionKeyListReqeustDate } from "./SubscriptionKeyListContainer";
import RequestKeyModal from "../modal/requestKey";
import DeleteConfirmModal from "components/templates/modal/small/confirm/delete";

type Props = {
  queryInfo: SubscriptionKeyListReqeustDate;
  columns: TableColumnsType<SubscriptionKeyListType>;
  data: SubscriptionKeyListType[];
  onChangePage: (page: number, pathname: string) => void;
  isFetching: boolean;
  refetch: () => void;
  isModal: { [key: string]: boolean | SubscriptionKeyListType };
  onChangeModal: (key: string) => void;
  onConfirmDelete: () => void;
};

export default function SubscriptionKeyListPresenter(
  props: Props
): JSX.Element {
  return (
    <SubscriptionKeyListStyled.SubscriptionKeyListWrapper>
      <CommonTable
        columns={props.columns}
        dataSource={props.data}
        queryInfo={props.queryInfo}
        onChangePage={(page) => props.onChangePage(page, "/subscription/keys")}
        loading={props.isFetching}
      />
      {props.isModal.register && (
        <RegisterKeyModal
          onModal={() => {
            props.onChangeModal("register");
          }}
          refetch={props.refetch}
        />
      )}
      {props.isModal.generate && (
        <GenerateKeyModal
          onModal={() => {
            props.onChangeModal("generate");
          }}
          refetch={props.refetch}
        />
      )}
      {props.isModal.replace && (
        <ReplaceKeyModal
          keyInfo={props.isModal.replace as SubscriptionKeyListType}
          onModal={() => {
            props.onChangeModal("replace");
          }}
          refetch={props.refetch}
        />
      )}
      {props.isModal.confirmDelete && (
        <DeleteConfirmModal
          label="key"
          onConfirmDelete={props.onConfirmDelete}
          onDelete={() => {
            props.onChangeModal("confirmDelete");
          }}
        />
      )}
    </SubscriptionKeyListStyled.SubscriptionKeyListWrapper>
  );
}
